/* jshint esversion: 6 */
// import 'external';

import $ from 'jquery';

export default class Theme {
    
    /**
     * [consoleLog description]
     *
     * @param {String} log [description]
     *
     * @return {[type]} [description]
     */
    consoleLog(log = '') {
        if (this.debug) {
            console.log('Theme: ' + log);
        }
    }
    
    /**
     * [constructor description]
     *
     * @param {[type]} options [description]
     *
     * @return {[type]} [description]
     */
    constructor(options) {
        
        this.debug = false;
        
        this.defaults = {
            el: 'body',
        };
        
        // merge options with defaults
        this.options = $.extend({}, this.defaults, options);
        
        // merge this.option to this
        $.extend(this, this.options);
        
        this.$el = $(this.el);
    }
    
    /**
     * [init description]
     *
     * @return {[type]} [description]
     */
    init() {
        if (this.check()) {
            this.prepare();
            this.run();
        }
    }
    
    /**
     * [check description]
     *
     * @return {[type]} [description]
     */
    check() {
        return this.$el.length;
    }
    
    /**
     * [destroy description]
     *
     * @return {[type]} [description]
     */
    cleanup() {
        
    }
    
    /**
     * [prepare description]
     *
     * @return {[type]} [description]
     */
    prepare() {
        this.consoleLog('prepare [jquery: ' + $().jquery + ']');
    }
    
    /**
     * [run description]
     *
     * @return {[type]} [description]
     */
    run() {
        this.consoleLog('run [jquery: ' + $().jquery + ']');
        // this.moveBottomBackground();
    }
    
    /**
     * [onWindowResize description]
     *
     * @return {[type]} [description]
     */
    onWindowResize() {
        if (!this.check()) {
            return;
        }
        // this.moveBottomBackground();
    }
    
    /**
     * [moveBottomBackground description]
     *
     * @return {[type]} [description]
     */
    moveBottomBackground() {
        
        if ($('#custom-text').length) {
            this.consoleLog('GO');
            let offset = $('#custom-text').height() - 280;
            $('#wrapper').css('background-position', 'center bottom ' + offset + 'px');
        }
    }
}



// WEBPACK FOOTER //
// ./modules/theme/js/theme.js